import styled from '@emotion/styled';
import { Flex } from 'antd';
import { rgba } from 'emotion-rgba';

export const Container = styled(Flex)`
  width: 100%;
  height: calc(100vh - 172px);
  background-color: ${({ theme }) => theme.colors.bgGrey};
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.strokeDarkGrey};
  box-shadow: 0 3px 8px 0 ${({ theme }) => rgba(theme.colors.dark, 0.1)};
  padding: 20px 30px;
`;

export const Header = styled(Flex)`
  height: 80px;
  border-radius: 10px 10px 0 0;
  padding-bottom: 20px;
`;

export const Title = styled(Flex)`
  font-weight: 600;
  font-size: 20px;
`;

export const Details = styled.div`
  color: ${({ theme }) => theme.colors.blackSecondary};
`;